import { PatientType, PatientInput } from "types";
import { useGetUserQuery } from "features/api";
import { getIsoDate } from "helpers";

type PatientInputByType = Record<PatientType, PatientInput>;

const usePatientInputByType = (): PatientInputByType => {
  const { data: user } = useGetUserQuery(undefined);

  return {
    self: {
      type: "self",
      relation: "self",
      ...(user && {
        firstName: user.firstName,
        middleName: user.middleName,
        lastName: user.lastName,
        birthday: user.birthday ? getIsoDate(user.birthday) : "",
        gender: user.gender,
      }),
    },
    child: {
      type: "child",
      relation: "child",
    },
    parent: {
      type: "parent",
      relation: "parent",
    },
    others: {
      type: "others",
      relation: "",
    },
  };
};

export { usePatientInputByType };
